import { userConstants } from './constantData';

const commonDimensions = [
  'v_tab', /* 33 */
  'v_provider_name', /* 35 */
  'v_collection_name', /* 36 */
];

export const MENU_DATA = {
  menu: {
    profiles: {
      hash: 'e-012.000.000.000.000.000',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
      ],
    },
    home: {
      hash: 'e-012.007.001.000.000.072',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
      ],
    },
    live: {
      hash: 'e-012.007.001.000.000.020',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
      ],
    },
    'on-demand': { /* catalog */
      hash: 'e-012.007.001.000.000.037',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
      ],
    },
    sports: {
      hash: 'e-012.007.001.000.000.038',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
      ],
    },
    kids: {
      hash: 'e-012.007.001.000.000.039',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
      ],
    },
    search: { /* searchbar */
      hash: 'e-012.007.001.000.000.032',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
      ],
    },
    setting: { /* settings */
      hash: 'e-012.007.001.000.000.131',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
      ],
    },
    'my-list': {
      hash: 'e-012.007.001.000.000.136',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
      ],
    },
    'my-page': {
      hash: 'e-012.007.001.000.000.279',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
      ],
    },
    log_out: {
      hash: 'e-012.007.001.000.000.073',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
      ],
    },
    back: {
      hash: 'e-012.007.001.000.000.028',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        ...commonDimensions,
      ],
    },
  },
};
